import type { Language } from "@newgenerated/shared/schema";
import { dictToList } from "@utils/dictUtils";
import { getFrontendTranslations } from "@newgenerated/shared/stubs";
import { assert } from "@utils/assertion";

export async function getGaDesignTranslations(language: Language): Promise<Map<string, string>> {
  const response = await getFrontendTranslations({ frontendProject: "DESIGN", isoCode: language });
  assert(response.kind === "success");
  return new Map(dictToList(response.data.keys.additionalProperties));
}
